import OneDocAiInteractiveChat from './components/OneDocAiInteractiveChat';
import MultilineAiEditor from './components/MultilineAiEditor';
//import NewChatAiWindow from './components/NewChatAiWindow';
import { useLocation, useParams } from 'react-router-dom';
import ChatSidebar from './components/ChatSidebar';
import Spinner from './../../components/Spinner';
import React, { useRef, useEffect, useLayoutEffect, lazy, Suspense } from 'react';
import { useAIChat } from './AiChatProvider';
import Header from '../../components/Header';
import { useSelector } from 'react-redux';
import { SummaryIcon } from './icons';
import { Layout, Button, Space } from 'antd';
import './index.css';
import OneDocAISidebar from './components/Chatsidebarnew';
import MainChatAiWindow from './components/MainChatAiWindow';
import ChatMenu from './components/ChatMenu';
import { FileTextOutlined } from '@ant-design/icons';

const AttachFilesDrawer = lazy(() => import('./components/AttachFilesDrawer'));

const { Content } = Layout;

const ITEMS_CONSTANT = {
  question: 'Ask a question',
  summarize: 'Summarize',
};

const getWorkspaceListOptions = (workspaces, context) => {
  const defaults = [
    { label: 'All', value: 'all', isWorkspace: false, isFile: false },
    ...workspaces.map((workspace) => ({ label: workspace?.title, value: workspace?.id, isWorkspace: true })),
  ];
  return [...defaults.filter((dflt) => dflt?.value !== context?.value), { ...context }].sort((a, b) =>
    a?.label?.localeCompare(b?.label)
  );
};

const OnedocAiPage = () => {
  const scrollRef = useRef();
  const messageRefs = useRef({});
  const aichatInputRef = useRef();
  const { id } = useParams();
  const location = useLocation();
  const { paginatedWorkspaceList } = useSelector((state) => state.organization);
  const { user } = useSelector((state) => state.user);
  const {
    currentConversation,
    context,
    isAnswering,
    sendMessage,
    setContext,
    removeLastMessage,
    fetchConversationById,
    loading,
    resetCurrentConversation,
    attachedFiles,
    setAttachedFiles,
    deleteConversationById,
    handleAbort,
  } = useAIChat();
  const messages = currentConversation?.messages || [];
  const isTopInStack = (index) => index === messages.length - 1;
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const items = [
    {
      id: 'question',
      label: ITEMS_CONSTANT.question,
      icon: <SummaryIcon width={18} height={18} />,
      onClick: () => {
        sendMessage(
          {
            content: ITEMS_CONSTANT.question,
            role: 'user',
            allowGoBack: true,
          },
          { fetchForFile: false, shouldNavigate: true, enableChatStream: false }
        );
        aichatInputRef.current?.focus();
      },
    },
  ];

  useEffect(() => {
    if (messages.length === 0) return;

    const lastMessage = messages[messages.length - 1];
    const lastMessageIndex = messages.length - 1;
    const isLatestMessageAI = lastMessage?.from === 'ai';
    const isNewlyGenerated = isLatestMessageAI && !!lastMessage.timestamp;

    // Only set minHeight for newly generated AI answers (not for history)
    if (isNewlyGenerated) {
      // Reset minHeight for all previous messages
      Object.keys(messageRefs.current).forEach((index) => {
        const idx = parseInt(index);
        if (idx < lastMessageIndex && messageRefs.current[idx]) {
          messageRefs.current[idx].style.minHeight = 'auto';
        }
      });

      // Set minHeight for latest AI answer to create space for streaming
      if (messageRefs.current[lastMessageIndex]) {
        const latestAnswerDiv = messageRefs.current[lastMessageIndex];
        latestAnswerDiv.style.minHeight = 'calc(100vh - 330px)';
        latestAnswerDiv.style.transition = 'min-height 0.3s ease';
      }
    }

    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [messages]);

  const isNewChat = location?.state?.isNewChat;

  useEffect(() => {
    if (id && !isNewChat) {
      fetchConversationById(id).then((res) => {
        const { meta_info = {} } = res || {};
        if ('context' in meta_info && 'value' in meta_info['context']) setContext(meta_info['context']);
        else setContext({ label: 'All', value: 'all', isWorkspace: false, isFile: false });
      });
    } else if (id === undefined) {
      resetCurrentConversation();
      setContext({ label: 'All', value: 'all', isWorkspace: false, isFile: false });
    }
  }, [id, isNewChat, setContext]);

  return (
    <>
      {/* <Header></Header> */}
      <Layout className="onedocai">
        <OneDocAISidebar />

        <Layout
          className="main-chat-window"
          style={{
            paddingTop: messages.length === 0 ? 'unset' : '18px',
            justifyContent: messages.length === 0 ? 'center' : 'space-between',
            position: 'relative',
          }}
        >
          <Space
            style={{
              position: 'absolute',
              top: '10px',
              right: '20px',
              zIndex: 1000,
            }}
          >
            <Button
              icon={<FileTextOutlined />}
              style={{
                fontSize: 20,
              }}
              onClick={() => setDrawerOpen(true)}
              type="text"
            />
            {drawerOpen && (
              <Suspense fallback={<div>Loading...</div>}>
                <AttachFilesDrawer
                  open={drawerOpen}
                  onClose={() => setDrawerOpen(false)}
                  attachedFiles={attachedFiles}
                />
              </Suspense>
            )}

            <ChatMenu
              chatId={currentConversation?.id}
              buttonStyle={{
                fontSize: '18px',
                padding: '4px 8px',
              }}
            />
          </Space>

          <Content ref={scrollRef} className="w-full chat-window-wrapper" style={{ flex: 'unset', marginTop: '20px' }}>
            <div className="responsive-chat-layout">
              {loading ? (
                <div
                  className="w-full h-full"
                  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
                >
                  <Spinner />
                </div>
              ) : messages.length === 0 ? (
                <MainChatAiWindow items={items} user={user} />
              ) : (
                <div className="chat-window w-full h-full">
                  <div className="w-full h-full chat-window-inner">
                    <div className="prompt-answers-wrapper">
                      {messages.map((message, index) => (
                        <div
                          key={index}
                          ref={(el) => {
                            if (el) messageRefs.current[index] = el;
                          }}
                        >
                          <OneDocAiInteractiveChat
                            pushQuestion={sendMessage}
                            aichatInputRef={aichatInputRef}
                            chat={message}
                            popQuestionIfAllowed={removeLastMessage}
                            isTopInStack={isTopInStack(index)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Content>

          <div className="prompt-box-wrapper">
            <div className="responsive-chat-layout w-full h-full">
              <div className="prompt-box w-full">
                <MultilineAiEditor
                  allowNavigationOnSubmit={true}
                  ref={aichatInputRef}
                  contextOptions={getWorkspaceListOptions(paginatedWorkspaceList, context)}
                  selectedContext={context?.value}
                  onContextOpenSelect={setContext}
                  onSubmit={sendMessage}
                  isAnswering={isAnswering}
                  showDropdownInput={true}
                  dropdownSize="lg"
                  attachedFiles={attachedFiles}
                  setAttachedFiles={setAttachedFiles}
                  handleAbort={handleAbort}
                />
              </div>
            </div>
          </div>
        </Layout>
      </Layout>
    </>
  );
};

export default OnedocAiPage;
